<div class="modal-header">
  <h5 class="modal-title" id="modal-basic-title">Clone Validation <b>{{validation.name}}</b> across TestCases </h5>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body" id="modal-body">
  <div class="common-section">
    <div class="row common-heading">
      <div class="col-8">
        TestCases Associated for Endpoint - {{this.validation.testCaseEndPoint.endPointName}}
      </div>
      <div class="col-4 float-right">
        <input type="text" name="searchVals" id="searchVals" class="form-control form-control-sm" placeholder="Search TestCase" [(ngModel)]="filterString" />
      </div>
    </div>
    <div class="common-table mt-3">
      <section class="testcase-sec">
        <table class="table table-stripped">
          <thead>
            <tr>
              <th width="5%"><input type="checkbox" ngbTooltip="Select All" [(ngModel)]="allSelected" (change)="selectAll($event)" /></th>
              <th>Associated TestCases</th>
              <th>Endpoint</th>
              <th class="text-center">Sequence</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngIf="testCaseEndPointList?.length === 0">
              <td colspan="3">No data found</td>
            </tr>
            <tr *ngFor="let testcaseEndPoint of testCaseEndPointList | tableFilter : {testCaseName : filterString}">
              <td> <input type="checkbox" [(ngModel)]="testcaseEndPoint.isSelected" (change)="onCheckboxChange($event,testcaseEndPoint)" /></td>
              <td>{{testcaseEndPoint.testCaseName}}</td>
              <td>{{testcaseEndPoint.endPointName}}</td>
              <td class="text-center">{{testcaseEndPoint.sequenceNumber}}</td>
            </tr>
          </tbody>
        </table>
      </section>
    </div>
  </div>
</div>
<div class="modal-footer">

  <div class="mr-auto" *ngIf="this.validation.expected.isExtracted === true">
    <label>If Expected EndPoint doesn't exist : </label>
    <span class="ml-2">
      <input id="ignore" type="radio" name="existing" [value]="true" [(ngModel)]="ignore">
      <label class="ml-1" for="ignore">Ignore Cloning</label>
    </span>

    <span class="ml-2">
      <input class="mt-1" id="throw-error" type="radio" name="existing" [value]="false" [(ngModel)]="ignore">
      <label class="ml-1" for="throw-error">Throw Error</label>
    </span>
  </div>

  <button type="submit" class="ml-5 text-right btn relay-btn save" (click)="cloneAcrossTestCase(testCaseEndPointList)">Clone Validation</button>
</div>